import styled from 'astroturf/react'
const colorBackgroundSecondary = 'var(--colorBackgroundSecondary, var(--coreColorNeutral100))'
import { useDeviceType } from '@calendly/ui/hooks/use-device-type'

import { ConfirmationFooter } from 'components/sso_confirmation_footer'
import { Links } from 'components/confirmation/links'
import _Card from "layout-Card.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/confirmation/pages/personalized_confirmation/marketing_banner/layout.js?styleId=Card";
import _EventDetails from "layout-EventDetails.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/confirmation/pages/personalized_confirmation/marketing_banner/layout.js?styleId=EventDetails";


const Card = /*#__PURE__*/styled('div', null, {
  displayName: "Card",
  styles: _Card,
  attrs: props => ({
    ...props,
    isPhone: useDeviceType('isPhone'),
    isTabletDown: useDeviceType('isTabletDown')
  })
})

const EventDetails = /*#__PURE__*/styled('div', null, {
  displayName: "EventDetails",
  styles: _EventDetails
})

export const Layout = ({ children, variant }) => (
  <Card>
    <EventDetails>
      {children}
      <ConfirmationFooter variant={variant} />
      <Links />
    </EventDetails>
  </Card>
)
